// extracted by mini-css-extract-plugin
export var circle = "_er-1";
export var exitConfirmationModal = "_er-5";
export var iframe = "_er-0";
export var offline = "_er-3";
export var online = "_er-2";
export var workstationSelectError = "_er-4";